module.exports = __webpack_public_path__ + "static/media/21.27603d35.jpg";